import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { Transaction } from "@onmo/graphql/graphql";
import { StaticImage } from "../StaticImage";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { Image } from "../../core/Image/Image";
import GZIcon from "../../../assets/icon/gamezone_coin/gamezone_coin_1x.webp";
import GZIcon2x from "../../../assets/icon/gamezone_coin/gamezone_coin_2x.webp";
import GZIcon3x from "../../../assets/icon/gamezone_coin/gamezone_coin_3x.webp";
import { getRewardImages, getRewardTitle } from "../../../models/rewardHistory";
import { useStyles } from "./TransactionHistoryCard.style";

interface ITransactionHistoryCardProps {
  rewardsHistory?: Transaction;
}

export const TransactionHistoryCard: FC<
  HTMLAttributes<HTMLDivElement> & ITransactionHistoryCardProps
> = (props) => {
  const classes = useStyles();
  const { rewardsHistory, className, ...otherProps } = props;
  const transactionHistoryImg = getRewardImages(rewardsHistory);

  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      <div className={classes.item}>
        <StaticImage
          src={transactionHistoryImg?.src}
          src2x={transactionHistoryImg?.src2x}
          src3x={transactionHistoryImg?.src3x}
          className={classes.itemImg}
        />
        <Typography variant={TypographyVariant.BodyB4Bold}>
          {getRewardTitle(rewardsHistory)}
        </Typography>
      </div>
      <div className={clsx(classes.item, classes.coinItem)}>
        <StaticImage
          src={GZIcon}
          src2x={GZIcon2x}
          src3x={GZIcon3x}
          className={classes.coinImg}
        />
        <Typography variant={TypographyVariant.HeadingH6Bold}>
          {rewardsHistory?.amount}
        </Typography>
      </div>
    </div>
  );
};
